import { required, Spacer } from '@jfs/ui-new'
import { TextInputNew } from '../../../../components/AdminInputs'
import { Dropdown } from '../../../../components/Dropdown'
import { styles } from '../../styles'

export const settlementDetailsFormData = (
  settlementFrequency: string,
  settlementStatus: string,
  isLinkToMAS: boolean,
  isEditMode: boolean,
  getLovsFromKey: any,
) => [
  {
    actionTitle: 'Proceed',
    key: 'settlementDetails',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'settlementAccount',
            ComponentName: TextInputNew,
            label: 'Account Number',
            placeholder: '',
            // value: settlementAccount,
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'settlementAccount',
          },
          {
            fieldName: 'ifsc',
            ComponentName: TextInputNew,
            label: 'IFSC',
            placeholder: '',
            // value: ifsc,
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'ifsc',
          },
          {
            fieldName: 'bankName',
            ComponentName: TextInputNew,
            label: 'Bank Name',
            placeholder: '',
            // value: bankName,
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'bankName',
          },
          {
            fieldName: 'branch',
            ComponentName: TextInputNew,
            label: 'Branch Name',
            placeholder: '',
            // value: branch,
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'branch',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'bankCity',
            ComponentName: TextInputNew,
            label: 'Bank City',
            editable: isEditMode,
            placeholder: '',
            // value: bankCity,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'branchCity',
          },
          {
            fieldName: 'beneficiaryName',
            ComponentName: TextInputNew,
            label: 'Beneficiary Name',
            placeholder: '',
            editable: isEditMode,
            // value: beneficiaryName,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'beneficiaryName',
          },
          {
            fieldName: 'settlementFrequency',
            ComponentName: isLinkToMAS ? TextInputNew : Dropdown,
            label: 'Settlement Frequency',
            title: 'Select',
            minWidth: 240,
            data: getLovsFromKey('settlementFrequency'),
            ...(!isLinkToMAS && { dataFieldToRead: 'description' }),
            ...styles.textinputStyle(isEditMode),
            type: isLinkToMAS ? 'body12' : 'default',
            testID: 'settlementFrequency',
          },
          {
            fieldName: 'settlementPlanID',
            ComponentName: TextInputNew,
            label: 'Settlement Plan ID',
            editable: isEditMode,
            // value: settlementPlanID,
            placeholder: '',
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'settlementPlanID',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'settlementStatus',
            ComponentName: isLinkToMAS ? TextInputNew : Dropdown,
            label: 'Settlement Status',
            minWidth: 240,
            title: isLinkToMAS ? undefined : 'Select',
            // editable: !isLinkToMAS ? false : isEditMode,
            // value: !isLinkToMAS ? settlementStatus : undefined,
            placeholder: '',
            data: isLinkToMAS
              ? undefined
              : [
                  { id: 1, value: 'Active' },
                  { id: 2, value: 'Cancelled' },
                  { id: 3, value: 'On Going' },
                  { id: 4, value: 'On Hold' },
                ],
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            type: isLinkToMAS ? 'body12' : 'default',
            testID: 'settlementStatus',
          },
          {
            fieldName: 'settlementAccountType',
            ComponentName: TextInputNew,
            label: 'Settlement Account Type(T+1)',
            editable: isEditMode,
            placeholder: '',
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'settlementAccountType',
          },
          {
            fieldName: 'dailyTransactionValue',
            ComponentName: TextInputNew,
            label: 'Daily Transaction Value',
            editable: isEditMode,
            placeholder: '',
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'dailyTransactionValue',
          },
          {
            fieldName: 'spacer3',
            ComponentName: Spacer,
          },
        ],
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]
